<template>
  <section id="dashboard">
    <!-- {{ DashboardDayValues }} -->
    <!-- <hr /> -->
    <!-- {{ DashboardMonthValues }} -->

    <!-- Welcome Card -->
    <v-container class="fill-height">
      <!-- <v-row>
                <v-col cols="12">
                    <v-card class="shadow-5">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_dashboard_card.svg')
                            "
                            cover
                            position="top"
                            class="align-center"
                            :max-height="welcomeCardHeight"
                        >
                            <v-card-title>
                                <v-container fill-height fluid>
                                    <v-row
                                        align="center"
                                        justify="space-between"
                                        dense
                                    >
                                        <v-col cols="12" md="9">
                                            <h2
                                                :class="[
                                                    isMobile ? 'h3' : 'h2',
                                                    isMobile && isDark
                                                        ? 'white--text'
                                                        : 'primary--text'
                                                ]"
                                                style="word-break: normal;"
                                            >
                                                ¡Hola, {{ userData.name }}!
                                            </h2>
                                            <p
                                                style="
                                                    word-break: normal;
                                                    line-height: normal;
                                                "
                                            >
                                                A continuación, te presentamos
                                                un resumen de las estadística de
                                                PBXBerry.
                                            </p>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="d-none d-md-block"
                                        >
                                            <v-img
                                                contain
                                                max-width="90%"
                                                class="mx-auto"
                                                :src="
                                                    require('@/assets/illustrations/chart.svg')
                                                "
                                                alt="Chart illustration"
                                            ></v-img>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-title>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row> -->

      <!-- Select Filter -->
      <v-row justify="end" align="center">
        <!-- <v-col cols="4" md="auto" class="text-right pr-0">
          <small class="font-weight-medium">Colas:</small>
        </v-col>

        <v-col cols="8" md="auto">
          <v-switch
            v-model="QueueSearch"
            inset
            @change="requestDashboard"
          ></v-switch>
        </v-col> -->

        <v-col cols="4" md="auto" class="text-right">
          <small class="font-weight-medium">Mostrar por:</small>
        </v-col>

        <v-col cols="8" md="auto" lg="2">
          <v-select
            :disabled="!render"
            :items="DateItems"
            v-model="DateSearch"
            filled
            rounded
            single-line
            dense
            class="rounded-small"
            hide-details
            @change="requestDashboard"
          ></v-select>
        </v-col>
      </v-row>

      <!-- Graphs -->

      <!-- Slider minicard for Mobiles -->
      <!-- <v-slide-group class="mt-2" v-if="isMobile && render">
        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>
      </v-slide-group> -->
      <!-- Minicards for Desktops -->
      <v-row>
        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="5">
          <v-card class="shadow-5" v-if="render" style="height: inehit;">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Total de Mensaje: {{ totalCalls }}
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart5"
                type="donut"
                :options="optionsDonutCalls"
                :series="serieDonut"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="7">
          <v-card class="shadow-5" v-if="render">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Distribución de mensajes por tiempo
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart6"
                type="line"
                :options="optionsLine"
                :series="serieLine"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-skeleton-loader
            :loading="!render"
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
            <v-card class="shadow-5">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Mensajes entrantes por usuario: {{ totalIncomingCalls }}
              </v-card-title>
              <v-card-text class="pb-16">
                <apexchart
                  ref="chart7"
                  type="bar"
                  :options="optionsBarIncomingCalls"
                  :series="barIncomingCalls"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="6">
          <v-skeleton-loader
            :loading="!render"
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
            <v-card class="shadow-5">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Mensajes salientes por usuario: {{ totalOutgoingCalls }}
              </v-card-title>
              <v-card-text class="pb-16">
                <apexchart
                  ref="chart8"
                  type="bar"
                  :options="optionsBarOutgoingCalls"
                  :series="barOutgoingCalls"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-skeleton-loader
            :loading="!render"
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
            <v-card class="shadow-5">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Estados entrantes
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart11"
                  type="donut"
                  :options="optionsDonutCallsWhatsappIncoming"
                  :series="serieDonutWhatsappIncoming"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="6">
          <v-skeleton-loader
            :loading="!render"
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
            <v-card class="shadow-5">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Estados salientes
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart12"
                  type="donut"
                  :options="optionsDonutCallsWhatsappOutgoing"
                  :series="serieDonutWhatsappOutgoing"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  inject: ["theme"],

  data() {
    return {
      render: false,
      userData: {},
      DateItems: ["Hoy", "Ayer", "Mes Actual", "Mes Anterior"],
      QueueSearch: false,
      DateSearch: "Hoy",
      // CONFIGURACIONES PARA GRÁFICAS
      totalCalls: 0,
      totalOutgoingCalls: 0,
      totalIncomingCalls: 0,
      optionsMiniCardsAreaIncoming: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Mensajes entrantes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#00BCD4"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionsMiniCardsAreaOutgoing: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Mensajes salientes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#2196F3"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },

      optionsMiniCardsBarIncoming: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Por usuarios entrantes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#625FA4"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionsMiniCardsBarOutgoing: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "por usuarios salientes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#AB47BC"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },

      optionsDonutCalls: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: ["Entrantes", "Salientes"],
      },
      optionsDonutCallsWhatsappIncoming: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: [],
      },

      optionsDonutCallsWhatsappOutgoing: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: [],
      },

      optionsBarIncomingCalls: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '11px', // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        fill: {
          //   colors: ["#6D71F9"],
          colors: ["#008FFB"],
        },
      },
      optionsBarOutgoingCalls: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '11px', // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        fill: {
          colors: ["#00E396"],
          //   colors: ["#FEB019"],
        },
      },

      optionsLine: {
        theme: {
          mode: "light",
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
          tickPlacement: "on",
        },
        colors: ["#008FFB", "#00E396", "#FEB019"],
      },

      // DATOS PARA GRÁFICAS
      serieDonut: [0, 0],
      serieDonutWhatsappOutgoing: [0, 0, 0],
      serieDonutWhatsappIncoming: [0, 0, 0],

      serieLine: [
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      barIncomingCalls: [
        {
          name: "Barra entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      barOutgoingCalls: [
        {
          name: "Barra salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      seriesMiniCardIncomingArea: [
        {
          name: "Mensajes entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesMiniCardOutgoingArea: [
        {
          name: "Mensajes salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      seriesMiniCardIncomingBar: [
        {
          name: "Mensajes entrantes por usuario",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesMiniCardOutgoingBar: [
        {
          name: "Mensajes salientes por usuario",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    };
  },

  computed: {
    // DashboardDayValues() {
    //     return this.$store.getters["dashboard/GET_DASHBOARD_DAY"];
    // },

    // DashboardMonthValues() {
    //     return this.$store.getters["dashboard/GET_DASHBOARD_MONTH"];
    // },

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    welcomeCardHeight() {
      if (this.$vuetify.breakpoint.mobile) {
        return "200";
      } else {
        return "150";
      }
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.requestDashboard();
  },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
  },

  updated() {
    this.changeThemeChart();
  },

  methods: {
    requestDashboard() {
      let value = this.DateSearch;

      this.render = false;
      this.clearAllGraphics();

      switch (value) {
        case "Hoy":
          this.getDashboardDayValues();
          break;
        case "Ayer":
          this.getDashboardYesterdayValues();
          break;

        case "Mes Actual":
          this.getDashboardMonthValues();
          break;
        case "Mes Anterior":
          this.getDashboardMonthYesterdayValues();
          break;

        default:
          this.getDashboardDayValues();
          break;
      }
    },

    async getDashboardDayValues() {
      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });
      try {
        // const response = await this.$store.dispatch(
        //   "dashboard/DASHBOARD_DAY_VALUES",
        //   { yesterday: false, is_queue: this.QueueSearch }
        // );

        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_WHATSAPP_DAY_VALUES",
          { yesterday: false }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getDashboardYesterdayValues() {
      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });
      try {
        // const response = await this.$store.dispatch(
        //   "dashboard/DASHBOARD_DAY_VALUES",
        //   { yesterday: true, is_queue: this.QueueSearch }
        // );
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_WHATSAPP_DAY_VALUES",
          { yesterday: true }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getDashboardMonthValues() {
      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_WHATSAPP_MONTH_VALUES",
          { yesterday: false }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
    async getDashboardMonthYesterdayValues() {
      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_WHATSAPP_MONTH_VALUES",
          { yesterday: true }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    graphics(response) {
      // Gráfica de Mini Cards Entrantes //
      // Área
      this.optionsMiniCardsAreaIncoming.title.text = response.starters;
      this.optionsMiniCardsAreaIncoming.xaxis.categories = response.graph3H;
      this.seriesMiniCardIncomingArea[0].data = response.graph3B;

      // Barras
      this.optionsMiniCardsBarIncoming.title.text = response.graph2Starters.data.length;
      this.seriesMiniCardIncomingBar[0].data = response.graph2Starters.data.map(function(
        value
      ) {
        return value.total === 0 ? value.cant_null : value.total;
      });
      this.optionsMiniCardsBarIncoming.xaxis.categories = response.graph2Starters.data.map(
        function(value) {
          return value.userId == null ? "No contestado" : value.user_name.name;
        }
      );

      // Gráfica de Mini Cards Salientes //
      // Área
      this.optionsMiniCardsAreaOutgoing.title.text = response.outgoing;
      this.optionsMiniCardsAreaOutgoing.xaxis.categories = response.graph3H;
      this.seriesMiniCardOutgoingArea[0].data = response.graph3A;

      //Barras
      this.optionsMiniCardsBarOutgoing.title.text = response.graph2Outgoing.data.length;
      this.seriesMiniCardOutgoingBar[0].data = response.graph2Outgoing.data.map(function(
        value
      ) {
        return value.total === 0 ? value.cant_null : value.total;
      });
      this.optionsMiniCardsBarOutgoing.xaxis.categories = response.graph2Outgoing.data.map(
        function(value) {
          return value.userId == null ? "No contestado" : value.user_name.name;
        }
      );

      // Fin mini cards //

      // Gráfica dona
      this.totalCalls = response.starters + response.outgoing;
      this.totalIncomingCalls = response.starters;
      this.totalOutgoingCalls = response.outgoing;
      this.serieDonut = [response.starters, response.outgoing];

      // Gráfica donas Whatsapp
      this.optionsDonutCallsWhatsappOutgoing.labels = response.starters_state.data.map(
        function(value) {
          return value.estado;
        }
      );
      this.serieDonutWhatsappOutgoing = response.starters_state.data.map(function(value) {
        return value.total;
      });

      this.optionsDonutCallsWhatsappIncoming.labels = response.outgoing_state.data.map(
        function(value) {
          return value.estado;
        }
      );
      this.serieDonutWhatsappIncoming = response.outgoing_state.data.map(function(value) {
        return value.total;
      });

      // Grafica de tres líneas (Entrantes y Salientes y Total)
      this.optionsLine.xaxis.categories = response.graph3H;
      this.serieLine[0].data = response.graph3B;
      this.serieLine[1].data = response.graph3A;
      this.serieLine[2].data = response.graph3C;

      // Gráfica de barras Entrantes
      this.optionsBarIncomingCalls.xaxis.categories = response.graph2Starters.data.map(
        function(value) {
          return value.userId == null ? "No contestado" : value.user_name.name;
        }
      );
      this.barIncomingCalls[0].data = response.graph2Starters.data.map(function(value) {
        return value.total === 0 ? value.cant_null : value.total;
      });

      // Gráfica de barras Salientes
      this.optionsBarOutgoingCalls.xaxis.categories = response.graph2Outgoing.data.map(
        function(value) {
          return value.userId == null ? "No contestado" : value.user_name.name;
        }
      );
      this.barOutgoingCalls[0].data = response.graph2Outgoing.data.map(function(value) {
        return value.total === 0 ? value.cant_null : value.total;
      });
    },

    clearAllGraphics() {
      this.serieLine = [
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ];

      this.optionsLine.xaxis.categories = [];
    },

    changeThemeChart() {
      if (this.$refs.chart1 !== undefined) {
        if (this.isDark) {
          this.$refs.chart1.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart2.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart3.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart4.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart5.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart6.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart7.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart8.updateOptions({ theme: { mode: "dark" } }, true);
        } else {
          this.$refs.chart1.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart2.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart3.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart4.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart5.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart6.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart7.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart8.updateOptions({ theme: { mode: "light" } }, true);
        }
      }
    },
  },
};
</script>
